import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import Axios from 'axios'
import router from './router'
import store from './store'

Vue.use(Vuex)
Axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  data:{
    dunkelmodus: false
  }
}).$mount('#app')
